import React from 'react';
import PropTypes from 'prop-types';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import ReviewSkeleton from '@hydra/common/components/ReviewSkeleton';
import ReviewCriteriaCTA from '@hydra/common/components/CTA/ReviewCriteriaCTA';
import { useReviewContext } from '@hydra/common/context/review';
import CriteriumChart from '@hydra/common/criterium/CriteriumChart';
import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumText from '@hydra/common/criterium/CriteriumText';

export const PjFbInsightReach = ({ criterium }) => {
  const { translate, moment } = useI18n();
  const { isFree } = useReviewContext();
  if (isFree) {
    return (
      <Criterium criterium={{ type: 'pj_fb_insight_reach', score: null, importance: 0, solvability: 0 }} clickable={false} align='center'>
        <ReviewCriteriaCTA
          text={<Translate component='div' content='pj_fb_insight_reach_cta_text' />}
          event='facebook'
        />
      </Criterium>
    );
  }

  if (!criterium) {
    return (
      <Criterium criterium={{ type: 'pj_fb_insight_reach', score: null, importance: 0, solvability: 0 }} clickable={false}>
        <ReviewSkeleton height={310} />
      </Criterium>
    );
  }

  const { data } = criterium;

  const organic = data.impressions_organic_unique;
  const viral = data.impressions_viral_unique;

  const chartData = [
    {
      name: translate('pj_so_impressions_organic_unique'),
      data: organic.map(([timestamp, value]) => {
        return ({
          day: moment(timestamp).format('D MMM'),
          x: timestamp,
          y: value
        });
      })
    },
    {
      name: translate('pj_so_impressions_viral_unique'),
      data: viral.map(([timestamp, value]) => {
        return ({
          day: moment(timestamp).format('D MMM'),
          x: timestamp,
          y: value
        });
      })
    }
  ];

  const getEmptySeries = series => {
    return series
      .map(data => data[1])
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0) === 0;
  };

  const missingMetrics = [organic, viral].filter(series => getEmptySeries(series)).length > 2;

  return (
    <Criterium criterium={criterium}>
      {missingMetrics && <CriteriumText firstLine={<Translate content='pj_facebook_missing_metrics_data' />} />}
      <CriteriumChart type='line' data={chartData} hasLegend hasTooltip frequency='day' />
    </Criterium>
  );
};

PjFbInsightReach.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      impressions_organic_unique: PropTypes.array,
      impressions_viral_unique: PropTypes.array
    })
  })
};

export default React.memo(PjFbInsightReach);
